import api from './api';

const devIssueService = {
  getAll: (filters = {}) => api.get('/admin/dev-issues/', { params: filters }),
  getById: (id) => api.get(`/admin/dev-issues/${id}`),
  create: (data) => api.post('/admin/dev-issues/', data),
  update: (id, data) => api.patch(`/admin/dev-issues/${id}`, data),
  delete: (id) => api.delete(`/admin/dev-issues/${id}`),
  move: (id, status, sortOrder) =>
    api.patch(`/admin/dev-issues/${id}/move`, { status, sort_order: sortOrder }),
  reorder: (items) => api.patch('/admin/dev-issues/reorder', { items }),
  getAssignableUsers: () => api.get('/admin/dev-issues/assignable-users'),

  // Comments
  addComment: (issueId, text) =>
    api.post(`/admin/dev-issues/${issueId}/comments`, { comment_text: text }),
  deleteComment: (issueId, commentId) =>
    api.delete(`/admin/dev-issues/${issueId}/comments/${commentId}`),

  // Attachments
  uploadAttachment: (issueId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post(`/admin/dev-issues/${issueId}/attachments`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  deleteAttachment: (issueId, attachmentId) =>
    api.delete(`/admin/dev-issues/${issueId}/attachments/${attachmentId}`),
  getDownloadUrl: (issueId, attachmentId) =>
    api.get(`/admin/dev-issues/${issueId}/attachments/${attachmentId}/download`),
};

export default devIssueService;
